import { render, staticRenderFns } from "./OverTheWire.vue?vue&type=template&id=743bcd3c&"
import script from "./OverTheWire.vue?vue&type=script&lang=js&"
export * from "./OverTheWire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports